import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, OutlinedInput, Typography } from '@material-ui/core';
import MaskedInput from 'react-text-mask';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class FormZipCode extends React.Component {
  render() {
    const {
      input,
      label,
      meta: { touched, error },
      ...custom
    } = this.props;

    return (
      <div>
        {label ? <Typography variant="caption">{label}</Typography> : null}
        <FormControl {...custom} error={touched && error ? true : false} margin="dense" variant="outlined">
          <OutlinedInput
            value={input.value}
            onChange={event => input.onChange(event.target.value)}
            id="zip-code"
            inputComponent={TextMaskCustom}
            disabled={custom.disabled}
            onBlur={event => input.onBlur(event)}
          />
          {touched && error ? <FormHelperText error>{error}</FormHelperText> : null}
        </FormControl>
      </div>
    );
  }
}

FormZipCode.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
};

export default FormZipCode;



// WEBPACK FOOTER //
// ./src/components/form/FormZipCode.js